import { useIsAuthenticated } from '@refinedev/core';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';

export const PublicRoute = ({ children }: { children: React.ReactNode }) => {
    const { data, isLoading } = useIsAuthenticated();
    const isAuthenticated = data?.authenticated;

    if (isLoading) {
        return (
            <Spin
                size="large"
                style={{
                    display: 'block',
                    margin: 'auto',
                    marginTop: '20vh',
                }}
            />
        );
    }

    if (isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
};
